import React, { useEffect, useState } from 'react';
import List from '@mui/material/List';
import { isMobile } from "react-device-detect";
import Divider from '@mui/material/Divider';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SettingsIcon from '@mui/icons-material/Settings';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { BrandingWatermark, Business, BusinessCenter, CardMembership, Chat, Forum, Image, ListAlt, Map, Money, NotificationAdd, NotificationsActive, NotificationAddTwoTone, Notifications, Payment, PermMedia, PostAdd, RateReview, Shop, ViewList, Wallet, VideoLibrary, PhotoLibrary, Smartphone, Home, CloudUpload, Info } from '@mui/icons-material';
import GroupIcon from '@mui/icons-material/Group';
import CategoryIcon from '@mui/icons-material/Category';
import ApprovalIcon from '@mui/icons-material/Approval';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import { usePermission } from '../../hooks/usePermission';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LocalStore } from '../../storage/authStore';
import { Typography } from '@mui/material';
import Cudel_logo from '../../assets/images/cudel_logo.svg'

const SidebarMenu = ({ setOpenDrawer }) => {
    const userDetail = LocalStore.getCurrentUserDetails();
    const loggedUser = LocalStore.getLoggedUserDetails();
    const role = (userDetail) ? userDetail.role : '0';
    const isSuperAdmin = loggedUser?.role?.title?.toString().trim().toLowerCase().replace(/[\s_-]+/g, '') === 'superadmin';
    const pathUrl = useLocation().pathname;
    const [subOrderOpen, setSubOrderOpen] = useState(0);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const open = useSelector(state => state.utilsSto.menu);
    const activeMenu = useSelector(state => state.utilsSto.menuDefaultSelected);

    useEffect(() => {
        if (pathUrl.startsWith('/settings')) {
            setSubOrderOpen(1);
        } else if (pathUrl.startsWith('/marketing')) {
            setSubOrderOpen(2);
        } else if (pathUrl.startsWith('/testing')) {
            setSubOrderOpen(3);
        } else if (pathUrl.startsWith('/admin/booking')) {
            setSubOrderOpen(4);
        } else if (pathUrl.startsWith('/notification')) {
            setSubOrderOpen(5);
        } else if (pathUrl.startsWith('/admin/users')) {
            setSubOrderOpen(6);
        } else if (pathUrl.startsWith('/admin/media')) {
            setSubOrderOpen(7);
        } else if (pathUrl.startsWith('/customer-app')) {
            setSubOrderOpen(8);
        } else if (pathUrl === '/admin/locations') {
            // standalone page - don't collapse any open submenu
        }
        else {
            setSubOrderOpen(0);
        }
    }, [pathUrl]);

    const handleNavigation = (path) => {
        setSubOrderOpen(0);
        navigate(path);
        setOpenDrawer(false);
    };

    // Permission hooks
    const bookingPermission = usePermission("booking");
    const servicePermission = usePermission("service");
    const userPermission = usePermission("service-expert");
    const categoryPermission = usePermission("category");
    const webCategoryPermission = usePermission("webCategory");
    const customerPermission = usePermission("customer");
    const systemSettingPermission = usePermission("system-setting");
    const rolePermission = usePermission("roles-and-permissions");
    const rewardProgramPermission = usePermission("reward-program");
    const adminMemberPermission = usePermission("register-admin");
    const bannerPermission = usePermission("banner");
    const marketingPermission = usePermission("marketing");
    const couponPermission = usePermission("coupon");
    const abandonCartPermission = usePermission("abandon-cart")
    const notificationPermission = usePermission("notification")
    const brandPermission = usePermission("brand");
    const lynsPermission = usePermission('lyns');
    const chatPermission = usePermission('chats');
    const bookingPaymentPermission = usePermission('booking-payment');
    const subscriptionPermission = usePermission('subscription');
    const expertWalletPermission = usePermission('expert-wallet-management');
    const mediaPermission = usePermission('media');
    const customerAppPermission = usePermission('customer-app');
    const guideLinesPermission = usePermission('guide-lines');
    const appSettingPermission = usePermission('app-setting');


    // Common styles for list items
    const listItemStyles = {
        minHeight: 30,
        justifyContent: open ? 'initial' : 'center',
        px: 2.5,
        py: 0.5,
    };

    const listItemIconStyles = {
        minWidth: 0,
        mr: 1,
        justifyContent: 'center',
    };

    const listItemTextStyles = {
        '& .MuiTypography-root': {
            fontSize: '.75rem'
        }
    };

    return (
        <List>
            <ListItem sx={{ borderBottom: '1px solid lightGray' }}>
                <Typography
                    variant="body1"
                    noWrap
                    component="div"
                    sx={{ width: '100%', cursor: 'pointer', textAlign: 'center' }}
                    onClick={(e) => navigate("/admin")}
                >
                    <img src={Cudel_logo} style={{ width: '7rem' }} />
                </Typography>
            </ListItem>
            {/* Dashboard */}
            <ListItem
                disablePadding
                onClick={() => handleNavigation("/admin")}
                sx={{ display: 'block' }}
                selected={activeMenu === "home"}
            >
                <ListItemButton sx={listItemStyles}>
                    <ListItemIcon sx={listItemIconStyles}>
                        <HomeIcon sx={{ fontSize: '1.25rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" sx={listItemTextStyles} />
                </ListItemButton>
            </ListItem>


            {/* Bookings */}
            {bookingPermission.canView && (
                <>
                    <ListItem
                        disablePadding
                        onClick={() =>
                            // setSubOrderOpen(!subOrderOpen)
                            setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 4) ? 0 : 4)
                        }
                        sx={{ display: 'block', bgcolor: subOrderOpen == 4 && 'lightGray' }}
                    >
                        <ListItemButton sx={listItemStyles}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <Business sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Booking" sx={listItemTextStyles} />
                            {(subOrderOpen == 4) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
                            {/* {subOrderOpen ? <ExpandLess sx={{fontSize:'1.25rem'}}/> : <ExpandMore sx={{fontSize:'1.25rem'}}/>} */}
                        </ListItemButton>
                    </ListItem>

                    <Collapse in={subOrderOpen == 4} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {/* Settings Subitems */}
                            {bookingPermission.canView && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "bookings"}
                                    onClick={() => handleNavigation("/admin/booking")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <ListAlt sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Booking List" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}

                            {bookingPermission.canCreate && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "create-booking"}
                                    onClick={() => handleNavigation("/admin/booking/new")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <PostAdd sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="New Booking" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}

                            {bookingPaymentPermission.canView &&
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "booking-payment"}
                                    onClick={() => handleNavigation("/admin/booking/payment")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <Payment sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Payment" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            }
                            {chatPermission.canView &&
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "chats"}
                                    onClick={() => handleNavigation("/admin/booking/chats")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <Chat sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Chats" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            }
                        </List>
                    </Collapse>
                </>
            )}

            {/* Customers */}
            {customerPermission.canView && (
                <ListItem
                    disablePadding
                    selected={activeMenu === "customer"}
                    onClick={() => handleNavigation("/admin/customers")}
                    sx={{ display: 'block' }}
                >
                    <ListItemButton sx={listItemStyles}>
                        <ListItemIcon sx={listItemIconStyles}>
                            <SupervisedUserCircleIcon sx={{ fontSize: '1.25rem' }} />
                        </ListItemIcon>
                        <ListItemText primary="Customers" sx={listItemTextStyles} />
                    </ListItemButton>
                </ListItem>
            )}

            {/* Brand */}
            {brandPermission.canView && (
                <ListItem
                    disablePadding
                    selected={activeMenu === "brand"}
                    onClick={() => handleNavigation("/admin/brand")}
                    sx={{ display: 'block' }}
                >
                    <ListItemButton sx={listItemStyles}>
                        <ListItemIcon sx={listItemIconStyles}>
                            <BrandingWatermark sx={{ fontSize: '1.25rem' }} />
                        </ListItemIcon>
                        <ListItemText primary="Brand" sx={listItemTextStyles} />
                    </ListItemButton>
                </ListItem>
            )}

            {/* Categories */}
            {categoryPermission.canView && (
                <ListItem
                    disablePadding
                    selected={activeMenu === "category"}
                    onClick={() => handleNavigation("/admin/category")}
                    sx={{ display: 'block' }}
                >
                    <ListItemButton sx={listItemStyles}>
                        <ListItemIcon sx={listItemIconStyles}>
                            <CategoryIcon sx={{ fontSize: '1.25rem' }} />
                        </ListItemIcon>
                        <ListItemText primary="Category" sx={listItemTextStyles} />
                    </ListItemButton>
                </ListItem>
            )}


            {/* Master Services */}
            {servicePermission.canView && (
                <ListItem
                    disablePadding
                    selected={activeMenu === "service"}
                    onClick={() => handleNavigation("/admin/services")}
                    sx={{ display: 'block' }}
                >
                    <ListItemButton sx={listItemStyles}>
                        <ListItemIcon sx={listItemIconStyles}>
                            <ShoppingCartIcon sx={{ fontSize: '1.25rem' }} />
                        </ListItemIcon>
                        <ListItemText primary="Master Services" sx={listItemTextStyles} />
                    </ListItemButton>
                </ListItem>
            )}



            {/* Service Experts */}
            {userPermission.canView && (
                <>
                    <ListItem
                        disablePadding
                        onClick={() =>
                            // setSubOrderOpen(!subOrderOpen)
                            setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 6) ? 0 : 6)
                        }
                        sx={{ display: 'block', bgcolor: subOrderOpen == 6 && 'lightGray' }}
                    >
                        <ListItemButton sx={listItemStyles}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <Business sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Service Experts" sx={listItemTextStyles} />
                            {(subOrderOpen == 6) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
                            {/* {subOrderOpen ? <ExpandLess sx={{fontSize:'1.25rem'}}/> : <ExpandMore sx={{fontSize:'1.25rem'}}/>} */}
                        </ListItemButton>
                    </ListItem>

                    <Collapse in={subOrderOpen == 6} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {userPermission.canView &&
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "user"}
                                    onClick={() => handleNavigation("/admin/users")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <ListAlt sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Expert List" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            }
                            {expertWalletPermission.canView &&
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "expert-wallet"}
                                    onClick={() => handleNavigation("/admin/users/wallet")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <Wallet sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Expert Wallet" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            }
                        </List>
                    </Collapse>
                </>
            )}

            {/* Settings */}
            {systemSettingPermission.canView && (
                <>
                    <ListItem
                        disablePadding
                        onClick={() =>
                            // setSubOrderOpen(!subOrderOpen)
                            setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 1) ? 0 : 1)
                        }
                        sx={{ display: 'block', bgcolor: subOrderOpen == 1 && 'lightGray' }}
                    >
                        <ListItemButton sx={listItemStyles}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <SettingsIcon sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Settings" sx={listItemTextStyles} />
                            {(subOrderOpen == 1) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
                            {/* {subOrderOpen ? <ExpandLess sx={{fontSize:'1.25rem'}}/> : <ExpandMore sx={{fontSize:'1.25rem'}}/>} */}
                        </ListItemButton>
                    </ListItem>

                    <Collapse in={subOrderOpen == 1} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {/* Settings Subitems */}
                            {adminMemberPermission.canView && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "members"}
                                    onClick={() => handleNavigation("/settings/members")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <GroupIcon sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Members" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}

                            <ListItem
                                disablePadding
                                selected={activeMenu === "features"}
                                onClick={() => handleNavigation("/settings/features")}
                                sx={{ display: 'block' }}
                            >
                                <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                    <ListItemIcon sx={listItemIconStyles}>
                                        <ApprovalIcon sx={{ fontSize: '1.25rem' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Features" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                </ListItemButton>
                            </ListItem>

                            {rolePermission.canView && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "roles"}
                                    onClick={() => handleNavigation("/settings/roles")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <GroupIcon sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Roles" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}


                            <ListItem
                                disablePadding
                                selected={activeMenu === "business"}
                                onClick={() => handleNavigation("/settings/business")}
                                sx={{ display: 'block' }}
                            >
                                <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                    <ListItemIcon sx={listItemIconStyles}>
                                        <BusinessCenter sx={{ fontSize: '1.25rem' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Business" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                </ListItemButton>
                            </ListItem>

                            {subscriptionPermission.canView &&
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "subscription"}
                                    onClick={() => handleNavigation("/settings/subscription")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <CardMembership sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Subscription" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            }
                            <ListItem
                                disablePadding
                                selected={activeMenu === "materialize-view"}
                                onClick={() => handleNavigation("/settings/materialize-view")}
                                sx={{ display: 'block' }}
                            >
                                <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                    <ListItemIcon sx={listItemIconStyles}>
                                        <ViewList sx={{ fontSize: '1.25rem' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Materialize View" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Collapse>
                </>
            )}

            {/* Marketing */}
            {marketingPermission.canView && (
                <>
                    <ListItem
                        disablePadding
                        onClick={() => setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 2) ? 0 : 2)}
                        sx={{ display: 'block', bgcolor: subOrderOpen == 2 && 'lightGray' }}
                    >
                        <ListItemButton sx={listItemStyles}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <Shop sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Marketing" sx={listItemTextStyles} />
                            {(subOrderOpen == 2) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
                        </ListItemButton>
                    </ListItem>

                    <Collapse in={subOrderOpen == 2} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {/* coupons Subitems */}
                            {couponPermission.canView && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "coupons"}
                                    onClick={() => handleNavigation("/marketing/coupons")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <Money sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Coupons" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}
                            {isSuperAdmin && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "testimonials"}
                                    onClick={() => handleNavigation("/marketing/testimonials")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <RateReview sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Testimonials" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}

                            {/* abandoned-cart */}
                            {abandonCartPermission.canView && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "abandoned-cart"}
                                    onClick={() => handleNavigation("/marketing/abandoned-cart")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <ShoppingCartIcon sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Abandoned Cart" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}
                            {/* {notificationPermission.canView && (
                            <ListItem
                                disablePadding
                                selected={activeMenu === "notification"}
                                onClick={() => handleNavigation("/marketing/notification")}
                                sx={{ display: 'block' }}
                            >
                                <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                    <ListItemIcon sx={listItemIconStyles}>
                                        <Notifications sx={{fontSize:'1.25rem'}}/>
                                    </ListItemIcon>
                                    <ListItemText primary="Notification" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                </ListItemButton>
                            </ListItem>
                            )} */}
                            {rewardProgramPermission.canView && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "wallet-reward"}
                                    onClick={() => handleNavigation("/marketing/reward-programs")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <EmojiEventsIcon sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Reward Programs" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}

                            {bannerPermission.canView && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "banners"}
                                    onClick={() => handleNavigation("/marketing/banners")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <Image sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Banners" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}
                        </List>
                    </Collapse>
                </>
            )}

            {/* ============= Notification ============ */}
            {notificationPermission.canView && (
                <>
                    <ListItem
                        disablePadding
                        onClick={() => setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 5) ? 0 : 5)}
                        sx={{ display: 'block', bgcolor: subOrderOpen == 5 && 'lightGray' }}
                    >
                        <ListItemButton sx={listItemStyles}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <NotificationsActive sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Notification" sx={listItemTextStyles} />
                            {(subOrderOpen == 5) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
                        </ListItemButton>
                    </ListItem>

                    <Collapse in={subOrderOpen == 5} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                            {notificationPermission.canView && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "notifications"}
                                    onClick={() => handleNavigation("/notification")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <NotificationAddTwoTone sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Notification_New" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}


                            {notificationPermission.canView && (
                                <ListItem
                                    disablePadding
                                    selected={activeMenu === "notification"}
                                    onClick={() => handleNavigation("/notification/old")}
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                        <ListItemIcon sx={listItemIconStyles}>
                                            <Notifications sx={{ fontSize: '1.25rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Notification_Old" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                    </ListItemButton>
                                </ListItem>
                            )}
                        </List>
                    </Collapse>
                </>
            )}

            {/* Lyns */}
            {lynsPermission.canView && (
                <ListItem
                    disablePadding
                    selected={activeMenu === "lyns"}
                    onClick={() => handleNavigation("/lyns")}
                    sx={{ display: 'block' }}
                >
                    <ListItemButton sx={listItemStyles}>
                        <ListItemIcon sx={listItemIconStyles}>
                            <Forum sx={{ fontSize: '1.25rem' }} />
                        </ListItemIcon>
                        <ListItemText primary="Lyns" sx={listItemTextStyles} />
                    </ListItemButton>
                </ListItem>
            )}

            {/* Media Management */}
            {mediaPermission.canView && (
                <>
                    <ListItem
                        disablePadding
                        onClick={() => setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 7) ? 0 : 7)}
                        sx={{ display: 'block', bgcolor: subOrderOpen == 7 && 'lightGray' }}
                    >
                        <ListItemButton sx={listItemStyles}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <PermMedia sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Media" sx={listItemTextStyles} />
                            {(subOrderOpen == 7) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
                        </ListItemButton>
                    </ListItem>

                    <Collapse in={subOrderOpen == 7} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {/* Video */}
                            <ListItem
                                disablePadding
                                selected={activeMenu === "media-video"}
                                onClick={() => handleNavigation("/admin/media/video")}
                                sx={{ display: 'block' }}
                            >
                                <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                    <ListItemIcon sx={listItemIconStyles}>
                                        <VideoLibrary sx={{ fontSize: '1.25rem' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Video" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                </ListItemButton>
                            </ListItem>

                            {/* Upload Media */}
                            <ListItem
                                disablePadding
                                selected={activeMenu === "media-upload"}
                                onClick={() => handleNavigation("/admin/media/upload")}
                                sx={{ display: 'block' }}
                            >
                                <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                                    <ListItemIcon sx={listItemIconStyles}>
                                        <CloudUpload sx={{ fontSize: '1.25rem' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Upload Media" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Collapse>
                </>
            )}

        {appSettingPermission.canView &&(
            <>
            <ListItem
                disablePadding
                onClick={() => setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 8) ? 0 : 8)}
                sx={{ display: 'block', bgcolor: subOrderOpen == 8 && 'lightGray' }}
            >
                <ListItemButton sx={listItemStyles}>
                    <ListItemIcon sx={listItemIconStyles}>
                        <Smartphone sx={{ fontSize: '1.25rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="App Setting" sx={listItemTextStyles} />
                    {(subOrderOpen == 8) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
                </ListItemButton>
            </ListItem>

            <Collapse in={subOrderOpen == 8} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem
                        disablePadding
                        selected={activeMenu === "home-screen"}
                        onClick={() => handleNavigation("/customer-app/home-screen")}
                        sx={{ display: 'block' }}
                    >
                        <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <Home sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Customer Home Screen" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem
                        disablePadding
                        selected={activeMenu === "header-management"}
                        onClick={() => handleNavigation("/customer-app/header-management")}
                        sx={{ display: 'block' }}
                    >
                        <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <Home sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Header Management" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem
                        disablePadding
                        selected={activeMenu === "sections"}
                        onClick={() => handleNavigation("/customer-app/sections")}
                        sx={{ display: 'block' }}
                    >
                        <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <ViewList sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Sections" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem
                        disablePadding
                        selected={activeMenu === "footer-management"}
                        onClick={() => handleNavigation("/customer-app/footer-management")}
                        sx={{ display: 'block' }}
                    >
                        <ListItemButton sx={{ ...listItemStyles, marginLeft: 2 }}>
                            <ListItemIcon sx={listItemIconStyles}>
                                <Home sx={{ fontSize: '1.25rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Footer Management" sx={{ ...listItemTextStyles, '& .MuiTypography-root': { fontSize: '.7rem' } }} />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Collapse>
            </>
        )}
            {/* Guidelines */}
            {guideLinesPermission.canView &&(
            <ListItem
                disablePadding
                onClick={() => handleNavigation("/admin/guidelines")}
                sx={{ display: 'block' }}
                selected={activeMenu === "guidelines"}
            >
                <ListItemButton sx={listItemStyles}>
                    <ListItemIcon sx={listItemIconStyles}>
                        <Info sx={{ fontSize: '1.25rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Guidelines" sx={listItemTextStyles} />
                </ListItemButton>
            </ListItem>
             )}
        </List>
    );
};

export default SidebarMenu;
